import React from 'react';
import { FadeIn } from './FadeIn';
export function Problem() {
  return <section className="py-16 md:py-24 px-4" data-id="element-134">
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <FadeIn data-id="element-136">
          <div className="bg-night-800 rounded-2xl p-8 md:p-12 shadow-lg border border-night-700 relative overflow-hidden" data-id="element-137">
            {/* Subtle background accent */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/5 rounded-full blur-[80px] pointer-events-none" data-id="element-138"></div>

            <h3 className="font-serif text-3xl md:text-4xl text-white mb-8 relative z-10" data-id="element-139">
              The "Wired-Tired" Loop
            </h3>

            <div className="space-y-6 text-lg text-cream/80 leading-relaxed relative z-10" data-id="element-140">
              <p data-id="element-141">
                By age 50, your internal thermostat is under siege. As estrogen
                drops, your brain's "cooling center" becomes hypersensitive.
              </p>
              <p data-id="element-142">
                It perceives a tiny change in room temp as a life-threatening
                heatwave. It triggers a hot flash to cool you down, followed
                immediately by a surge of cortisol (the stress hormone) to wake
                you up and deal with the "emergency."
              </p>
              <p className="font-medium text-amber-400 text-xl pt-4 border-t border-night-700" data-id="element-143">
                This creates the "Wired-Tired" loop: you are physically
                exhausted, but biologically incapable of falling back asleep.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}